import { TabStack } from "@molecules/index"

import { TableViewPhasesProps } from "./TableViewPhases.types"

export default function TableViewPhases(props: TableViewPhasesProps) {
    const { children } = props

    return (
        <TabStack variant="contained" size="md">
            {children}
        </TabStack>
    )
}
